<template>
  <div>
    <a-drawer
      :title="modalTit"
      :width="700"
      :visible="checkVisible"
      :mask-closable="false"
      @close="onClose"
    >
      <a-form
        :form="form"
        layout="vertical"
        class="statistic-filter"
        hide-required-mark
      >
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${infoClass}：`"
        >
          <a-checkbox-group
            v-model="checkedList"
            :options="plainOptions"
            @change="onChange"
          />
        </a-form-item>
        <a-form-item
          :label-col="formItemLayout.labelCol"
          :wrapper-col="formItemLayout.wrapperCol"
          :label="`${infoFromTit}：`"
        >
          <div
            v-for="(items,index) in fromArrayList"
            :key="index"
            class="form-item-div"
          >
            <a-cascader
              :options="items.options"
              :value="items.values"
              change-on-select
              :placeholder="selectPlaceholder"
              class="select-120"
              @popupVisibleChange="handlePopupVisibleChange($event,items,index)"
              @change="onChangeCascader($event,items,index)"
            />
            <a-icon
              v-if="fromArrayList.length > 1"
              type="minus-circle"
              class="delete-icon"
              @click="handleDelete(index)"
            />
          </div>
          <div class="add-div">
            <span
              class="addItemBtn"
              @click="handleAddItem"
            >
              <a-icon
                type="plus"
                class="icon"
              />{{ $t('message["1561"]') }}</span>
          </div>
        </a-form-item>
      </a-form>

      <div class="team-seting-footer">
        <a-button
          class="save-btn"
          type="primary"
          :loading="confirmLoading"
          @click="onSave"
        >
          {{ $t('message["915"]') }}
        </a-button>
        <a-button @click="onClose">
          {{ $t('message["896"]') }}
        </a-button>
        <a-button
          class="delete"
          @click="deleteAll"
        >
          {{ $t('message["908"]') }}
        </a-button>
      </div>
    </a-drawer>
  </div>
</template>
<script>
import { mapState, mapActions, mapMutations } from 'vuex'
import { getLang } from '@/lib/storage'
export default {
  props: {
    time: {
      type: Object,
      default: () => ({})
    }
  },
  data () {
    return {
      infoTypeValue: '0',
      checkedList: [],
      form: this.$form.createForm(this),
      visible: false,
      plainOptions: [],
      permissionDatas: [],
      fromArrayList: [],
      loaclIndexFilterDatas: null
    }
  },
  computed: {
    ...mapState('statistic', ['checkVisible', 'indexFilterDatas', 'confirmLoading']),
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    modalTit () {
      return this.$t('message["960"]')
    },
    infoFromTit () {
      return this.$t('message["1370"]')
    },
    infoClass () {
      return this.$t('message["1372"]')
    },
    formItemLayout () {
      const isEnglish = this.getLang() === 'en'
      return {
        labelCol: { span: isEnglish ? 6 : 3 },
        wrapperCol: { span: isEnglish ? 18 : 20 }
      }
    }
  },
  watch: {
    indexFilterDatas () {
      this.setFilterDatas()
    }
  },
  methods: {
    ...mapActions('statistic', ['fetchGetIndexDetailDatas']),
    ...mapMutations('statistic', ['setConfirmLoading', 'setCheckVisible', 'setCheckParams']),
    getLang,
    setFilterDatas () {
      if (!this.indexFilterDatas) {
        return
      }
      this.loaclIndexFilterDatas = this.indexFilterDatas
      let tempvType = []
      if (Array.isArray(this.indexFilterDatas.info_type.options)) {
        this.indexFilterDatas.info_type.options.map(value => {
          tempvType.push({
            label: value.name,
            value: value.id
          })
        })
      }
      this.plainOptions = tempvType
      this.fromArrayList.push({
        options: this.formateInfoFormDatas(this.indexFilterDatas.from),
        values: []
      })
    },
    formateInfoFormDatas (array) {
      let tempv = []
      array.map(value => {
        let json = {
          label: value.fieldname,
          value: value.fieldkey + '-' + value.id,
          children: []
        }
        if (value.child) {
          const child2 = Object.values(value.child)
          child2.map(vvs => {
            let json2 = {
              label: vvs.fieldname,
              value: vvs.fieldkey,
              children: []
            }
            if (vvs.options) {
              for (const key in vvs.options) {
                json2.children.push({
                  label: vvs.options[key].name,
                  value: vvs.options[key].id
                })
              }
            }
            json.children.push(json2)
          })
        }
        tempv.push(json)
      })
      return tempv
    },
    handlePopupVisibleChange (e, items, index) {
      if (!e) {
        if (Array.isArray(items.values) && items.values.length === 2) {
          let tempv = JSON.parse(JSON.stringify(items))
          tempv.values = []
          this.$set(this.fromArrayList, index, tempv)
        }
      }
    },
    onChange (checkedList) {
      this.checkedList = checkedList
    },
    handleDelete (index) {
      this.fromArrayList = this.fromArrayList.slice(0, index).concat(this.fromArrayList.slice(index + 1))
    },
    deleteAll () {
      this.checkedList = []
      this.fromArrayList = []
      this.setConfirmLoading(false)
      this.setCheckVisible(false)
      this.setCheckParams(null)
      this.setFilterDatas()
      this.$delete(this.time, 'from_info')
      this.$delete(this.time, 'info_type')
      this.fetchGetIndexDetailDatas({
        page: 1,
        ...this.time
      })
    },
    handleAddItem () {
      this.fromArrayList.push({
        options: this.formateInfoFormDatas(this.loaclIndexFilterDatas.from),
        values: []
      })
    },
    onChangeCascader (e, item, index) {
      item.values = e
      this.$set(this.fromArrayList, index, item)
    },
    onClose () {
      this.setConfirmLoading(false)
      this.setCheckVisible(false)
    },
    onSave () {
      this.setConfirmLoading(true)
      const params = {
        from_info: this.getSaveFromTypeDatas(),
        info_type: this.checkedList,
        page: 1
      }
      this.fetchGetIndexDetailDatas({ ...params, ...this.time })
      if (params.from_info.length === 0 && params.info_type.length === 0) {
        this.setCheckParams(null)
      } else {
        this.setCheckParams(params)
      }
    },
    getSaveFromTypeDatas () {
      let tempv = []
      this.fromArrayList.map(value => {
        if (value.values.length) {
          let json = {}
          if (value.values.length === 1) {
            let [firstItem] = value.values
            if (firstItem.indexOf('-') >= 0) {
              const key = firstItem.split('-')[0]
              json[key] = 0
            }
          } else if (value.values.length > 1) {
            json[value.values[1]] = value.values[2]
          }
          tempv.push(json)
        }
      })
      return tempv
    }
  }
}
</script>
<style lang="scss" scoped>
.statistic-filter::v-deep {
  .ant-form-item-label {
    text-align: right !important;
  }
}
.form-item-div {
  margin-bottom: 16px;
}
.edit-btn {
  margin-bottom: 14px;
}
.add-div {
  margin-top: 24px;
  .addItemBtn {
    background-color: #f5f5f5;
    padding: 8px 16px 8px 16px;
    border-radius: 4px;
    cursor: pointer;
    .icon {
      margin-right: 4px;
    }
  }
}

.delete-icon {
  font-size: 20px;
  margin-left: 12px;
  color: #b3b3b3;
  cursor: pointer;
}
.team-seting-footer {
  position: absolute;
  left: 0;
  bottom: 0;
  width: 100%;
  border-top: 1px solid #e9e9e9;
  padding: 10px 16px;
  background-color: #fff;
  text-align: left;
  .save-btn {
    margin-left: 90px;
    margin-right: 12px;
  }
  .delete {
    background-color: rgba(245, 118, 118, 1);
    color: rgba(255, 255, 255, 1);
  }
}

.checkbox-group-p {
  width: 500px;
  .parent-span {
    width: 150px;
    .child-permission {
      margin-left: 24px;
      span {
        display: inline-block;
      }
    }
  }
}
.margin-left-16 {
  margin-left: 16px;
}
</style>
